import { Menu, Transition } from '@headlessui/react';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import { Fragment } from 'react';
import { OwnerOptionsResource } from '..';
import { SearchParameter, SearchParameters } from '../../../../../ListFilter/Types';
import MenuItems from './MenuItems';

interface Props {
  updatingSearchParameters: (searchParameter: SearchParameter) => void;
  searchParameters: SearchParameters;
  ownerOptionsData: OwnerOptionsResource;
}

function Dropdown({ updatingSearchParameters, searchParameters, ownerOptionsData }: Props) {
  return (
    <Transition
      as={Fragment}
      enter="transition ease-out duration-100"
      enterFrom="transform opacity-0 scale-95"
      enterTo="transform opacity-100 scale-100"
      leave="transition ease-in duration-75"
      leaveFrom="transform opacity-100 scale-100"
      leaveTo="transform opacity-0 scale-95"
    >
      <Menu.Items
        className={clsx(
          'bg-white drop-shadow-md rounded-md mt-2 border-1',
          'border-solid border-gray-300 py-2 pl-2 pr-1 z-[3] absolute',
        )}
      >
        <div className="py-1 max-h-96 relative overflow-scroll">
          <MenuItems
            searchParameters={searchParameters}
            updatingSearchParameters={updatingSearchParameters}
            ownerOptionsData={ownerOptionsData}
          />
        </div>
      </Menu.Items>
    </Transition>
  );
}

export default observer(Dropdown);
